import React from "react";

import * as styles from "./TestStyle.module.css";

type TestInputProps = Readonly<{
  label: string;
  buttonText: string;
  actionURL: string;
  actionName: string;
}>;

export const TestInput = ({ label, buttonText, actionURL, actionName }: TestInputProps) => (
  <div>
    <form action={actionURL} method="GET" target="_blank">
      <span className={styles.inputLabel}>{label}</span>
      <input className={styles.input} type="text" name={actionName} required></input>
      <button className={styles.testButton} type="submit">
        {buttonText}
      </button>
    </form>
  </div>
);
